import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet/dist/leaflet.css';
import 'vue-popperjs/dist/vue-popper.css';

import '@babel/polyfill';
import Vue from 'vue';
import vueMoment from 'vue-moment';

import App from './App.vue';
import CheckPermission from './components/helpers/CheckPermission.vue';
import { address } from './filters/address';
import { avatarUrl, mediaUrl } from './filters/mediaUrl';
import { i18n } from './i18n';
import router from './router';
import store from './store/store';

Vue.use(vueMoment as any);
Vue.filter('mediaUrl', mediaUrl);
Vue.filter('avatarUrl', avatarUrl);
Vue.filter('address', address);
Vue.component('check-permission', CheckPermission);

Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
